<h1 mat-dialog-title>
  {{ (isEdit ? 'map.sidebar.shape.style_form.title_edit' : 'map.sidebar.shape.style_form.title_new') | translate }}
</h1>
<div mat-dialog-content [formGroup]="styleForm">
  <div class="row">
    <div class="col-8 form-field-container">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{ 'map.sidebar.shape.style_form.style_title' | translate }}</mat-label>
        <input matInput [readonly]="isEdit ? 'true' : null" formControlName="styleTitle" />
        <mat-error *ngIf="styleForm.get('styleTitle').hasError('required')"
          >{{ 'common.required_field' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col d-flex align-items-center">
      <button mat-stroked-button color="primary" (click)="newRule()">
        {{ 'map.sidebar.shape.style_form.rule_add' | translate }}
      </button>
    </div>
  </div>

  <div class="rules-container">
    <div *ngFor="let rule of rules">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ rule.rule_name }}
          </mat-panel-title>
          <mat-panel-description class="d-flex justify-content-end align-items-center">
            <mat-icon color="primary" (click)="deleteRule(rule.id)">delete</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form #f="ngForm" class="grid">
            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'map.sidebar.shape.style_form.rule_name' | translate }}</mat-label>
                  <!-- <input matInput (blur)="onRuleNameChange($event, rule.id)"> -->
                  <input matInput [required]="isRequired('rule_name')" name="rule_name" [(ngModel)]="rule.rule_name" />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'map.sidebar.shape.style_form.rule_symbolizer' | translate }}</mat-label>
                  <!-- <mat-select required (selectionChange)="onSymbolizerSelected($event, rule.id)"> -->
                  <mat-select [required]="isRequired('type')" name="type" [(ngModel)]="rule.type">
                    <mat-option *ngFor="let symbol of symbolizers" [value]="symbol">
                      <div class="d-flex align-items-center">
                        <div class="text-capitalize">{{ symbol }}</div>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="rule.type?.length > 0">
              <!-- MAX SCALE -->
              <div class="col">
                <div class="d-flex gap-2 align-items-center">
                  <label>{{ 'map.sidebar.shape.style_form.maxScale' | translate }}</label>
                  <mat-icon
                    inline="true"
                    matTooltip="Lo stile viene mostrato per scale al di SOTTO del valore selezionato"
                    >info</mat-icon
                  >
                  <mat-icon inline="true" matTooltip="Reset" (click)="rule.maxScale = 0">delete</mat-icon>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <mat-slider name="maxScale" min="1000" max="40000000" step="1000" tickInterval="auto">
                    <input
                      matSliderThumb
                      [required]="isRequired('maxScale')"
                      [(ngModel)]="rule.maxScale"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-slider>
                  <label>{{ rule.maxScale | number }}</label>
                </div>
              </div>
              <!-- MIN SCALE -->
              <div class="col">
                <div class="d-flex gap-2 align-items-center">
                  <label>{{ 'map.sidebar.shape.style_form.minScale' | translate }}</label>
                  <mat-icon
                    inline="true"
                    matTooltip="Lo stile viene mostrato per scale al di SOPRA del valore selezionato"
                    >info</mat-icon
                  >
                  <mat-icon inline="true" matTooltip="Reset" (click)="rule.minScale = 0">delete</mat-icon>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <mat-slider name="minScale" min="1000" max="40000000" step="1000" tickInterval="auto">
                    <input
                      matSliderThumb
                      [required]="isRequired('minScale')"
                      [(ngModel)]="rule.minScale"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-slider>
                  <label>{{ rule.minScale | number }}</label>
                </div>
              </div>
            </div>
            <!-- POINT -->
            <div *ngIf="rule.rule_name?.length > 0 && rule.type == 'point'" class="grid">
              <div class="row">
                <div class="col">
                  <mat-form-field>
                    <mat-label>{{ 'map.sidebar.shape.style_form.pointSymbol' | translate }}</mat-label>
                    <mat-select [required]="isRequired('symbol', 'point')" name="symbol" [(ngModel)]="rule.symbol">
                      <mat-option
                        *ngFor="let symbolValue of stylesConfiguration.point.symbol.values; let index"
                        [value]="symbolValue"
                      >
                        <div class="d-flex align-items-center">
                          <div class="text-capitalize">{{ symbolValue }}</div>
                        </div>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field>
                    <mat-label>{{ 'map.sidebar.shape.style_form.fill_color' | translate }}</mat-label>
                    <input
                      type="color"
                      matInput
                      [required]="isRequired('color', 'point')"
                      name="color"
                      [(ngModel)]="rule.color"
                      value="#ff0000"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label>{{ 'map.sidebar.shape.style_form.size' | translate }}*</label>
                  <div class="d-flex gap-2 align-items-center">
                    <mat-slider name="size" min="1" max="100" step="1" tickInterval="auto">
                      <input
                        matSliderThumb
                        [(ngModel)]="rule.size"
                        [ngModelOptions]="{ standalone: true }"
                        [required]="isRequired('size', 'point')"
                        value="1"
                      />
                    </mat-slider>
                    <label>{{ rule.size }}</label>
                  </div>
                </div>
                <div class="col">
                  <mat-label>{{ 'map.sidebar.shape.style_form.fill_opacity' | translate }}</mat-label>
                  <div class="d-flex gap-2 align-items-center">
                    <mat-slider name="opacity" min="0" max="1" step="0.05" tickInterval="auto">
                      <input
                        matSliderThumb
                        [(ngModel)]="rule.opacity"
                        [ngModelOptions]="{ standalone: true }"
                        [required]="isRequired('opacity', 'point')"
                        value="1"
                      />
                    </mat-slider>
                    <label>{{ rule.opacity }}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- LINE -->
            <div *ngIf="rule.rule_name?.length > 0 && rule.type == 'line'" class="grid">
              <div class="row">
                <div class="col">
                  <mat-form-field>
                    <mat-label>
                      {{ 'map.sidebar.shape.style_form.stroke_pattern' | translate }}
                    </mat-label>

                    <input
                      matInput
                      [required]="isRequired('pattern', 'line')"
                      name="pattern"
                      [(ngModel)]="rule.pattern"
                    />
                    <mat-icon inline="true" matSuffix matTooltip="'3,1' corrispondono a tre dash e uno spazio "
                      >info</mat-icon
                    >
                    <mat-icon inline="true" matSuffix matTooltip="Reset" (click)="rule.pattern = ''">delete</mat-icon>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field>
                    <mat-label>{{ 'map.sidebar.shape.style_form.stroke_color' | translate }}</mat-label>
                    <input
                      type="color"
                      matInput
                      [required]="isRequired('color', 'line')"
                      name="color"
                      [(ngModel)]="rule.color"
                      value="#ff0000"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-label>{{ 'map.sidebar.shape.style_form.stroke_width' | translate }}*</mat-label>
                  <div class="d-flex gap-2 align-items-center">
                    <mat-slider name="width" min="1" max="30" step="1" tickInterval="auto">
                      <input
                        matSliderThumb
                        [(ngModel)]="rule.width"
                        [ngModelOptions]="{ standalone: true }"
                        [required]="isRequired('width', 'line')"
                      />
                    </mat-slider>
                    <label>{{ rule.width }}</label>
                  </div>
                </div>
                <div class="col">
                  <mat-label>{{ 'map.sidebar.shape.style_form.stroke_opacity' | translate }}</mat-label>
                  <div class="d-flex gap-2 align-items-center">
                    <mat-slider name="opacity" min="0" max="1" step="0.05" tickInterval="auto">
                      <input
                        matSliderThumb
                        [(ngModel)]="rule.opacity"
                        [ngModelOptions]="{ standalone: true }"
                        [required]="isRequired('opacity', 'line')"
                      />
                    </mat-slider>
                    <label>{{ rule.opacity }}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- POLYGON -->
            <div *ngIf="rule.rule_name?.length > 0 && rule.type == 'polygon'" class="grid">
              <div class="row">
                <div class="col">
                  <label>{{ 'map.sidebar.shape.style_form.fill_opacity' | translate }}</label>
                  <div class="d-flex gap-2 align-items-center">
                    <mat-slider name="opacity" min="0" max="1" step="0.05" tickInterval="auto">
                      <input
                        matSliderThumb
                        [(ngModel)]="rule.opacity"
                        [ngModelOptions]="{ standalone: true }"
                        [required]="isRequired('opacity', 'polygon')"
                      />
                    </mat-slider>
                    <label>{{ rule.opacity }}</label>
                  </div>
                </div>
                <div class="col">
                  <mat-form-field>
                    <mat-label>{{ 'map.sidebar.shape.style_form.fill_color' | translate }}</mat-label>
                    <input
                      type="color"
                      matInput
                      [required]="isRequired('color', 'polygon')"
                      name="color"
                      [(ngModel)]="rule.color"
                      value="#ff0000"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label>{{ 'map.sidebar.shape.style_form.stroke_width' | translate }}*</label>
                  <div class="d-flex gap-2 align-items-center">
                    <mat-slider name="stroke_width" min="1" max="100" step="1" tickInterval="auto">
                      <input
                        matSliderThumb
                        [(ngModel)]="rule.stroke_width"
                        [ngModelOptions]="{ standalone: true }"
                        [required]="isRequired('stroke_width', 'polygon')"
                      />
                    </mat-slider>
                    <label>{{ rule.stroke_width }}</label>
                  </div>
                </div>
                <div class="col">
                  <label>{{ 'map.sidebar.shape.style_form.stroke_opacity' | translate }}</label>
                  <div class="d-flex gap-2 align-items-center">
                    <mat-slider name="stroke_opacity" min="0" max="1" step="0.05" tickInterval="auto">
                      <input
                        matSliderThumb
                        [(ngModel)]="rule.stroke_opacity"
                        [ngModelOptions]="{ standalone: true }"
                        [required]="isRequired('stroke_opacity', 'polygon')"
                      />
                    </mat-slider>
                    <label>{{ rule.stroke_opacity }}</label>
                  </div>
                </div>
                <div class="col">
                  <mat-form-field>
                    <mat-label>{{ 'map.sidebar.shape.style_form.stroke_color' | translate }}</mat-label>
                    <input
                      type="color"
                      matInput
                      [required]="isRequired('stroke_color', 'polygon')"
                      name="stroke_color"
                      [(ngModel)]="rule.stroke_color"
                      value="#ff0000"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- LABEL -->
            <div *ngIf="rule.rule_name?.length > 0 && rule.type?.length > 0" class="grid">
              <div class="row">
                <div class="col">
                  <section>
                    <mat-checkbox [(ngModel)]="rule.showLabel" name="showLabel">Label </mat-checkbox>
                  </section>
                </div>
              </div>
              <div class="grid" *ngIf="rule.showLabel">
                <ng-container *ngTemplateOutlet="labelTemplate; context: rule"></ng-container>
              </div>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{ 'common.close' | translate }}</button>
  <button mat-raised-button color="primary" (click)="save()">{{ 'common.save' | translate }}</button>
</div>

<ng-template #labelTemplate let-label="label">
  <div class="row">
    <div class="col-4">
      <mat-form-field>
        <mat-label>{{ 'map.sidebar.shape.style_form.font_family' | translate }}</mat-label>
        <mat-select [required]="isRequired('font_family', 'label')" name="font_family" [(ngModel)]="label.font.family">
          <mat-option
            *ngFor="let fontFamily of stylesConfiguration.label.font.family.values; let index"
            [value]="fontFamily"
          >
            <div class="d-flex align-items-center">
              <div class="text-capitalize">{{ fontFamily }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field>
        <mat-label>{{ 'map.sidebar.shape.style_form.font_weight' | translate }}</mat-label>
        <mat-select [required]="isRequired('font_weight', 'label')" name="font_weight" [(ngModel)]="label.font.weight">
          <mat-option
            *ngFor="let fontWeight of stylesConfiguration.label.font.weight.values; let index"
            [value]="fontWeight"
          >
            <div class="d-flex align-items-center">
              <div class="text-capitalize">{{ fontWeight }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field>
        <mat-label>{{ 'map.sidebar.shape.style_form.fill_color' | translate }}</mat-label>
        <input
          type="color"
          matInput
          [required]="isRequired('font_color', 'label')"
          name="font_color"
          [(ngModel)]="label.fill"
          value="'#ff0000'"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <mat-label>{{ 'map.sidebar.shape.style_form.label_type' | translate }}</mat-label>
      <mat-radio-group
        [(ngModel)]="label.label_type"
        class="d-flex flex-column align-items-start justify-content-center gap-2 pt-2"
      >
        <mat-radio-button [checked]="label.label_type == 2" name="label_type" value="2"> Colonna </mat-radio-button>
        <mat-radio-button [checked]="label.label_type == 1" name="label_type" value="1"> Testo </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="col-4">
      <mat-form-field *ngIf="label.label_type == 1">
        <mat-label>{{ 'map.sidebar.shape.style_form.label_text' | translate }}</mat-label>
        <input
          matInput
          [required]="isRequired('font_value', 'label')"
          name="font_value"
          [(ngModel)]="label.font.value"
        />
      </mat-form-field>
      <mat-form-field *ngIf="label.label_type == 2">
        <mat-label>{{ 'map.sidebar.shape.style_form.label_column' | translate }}</mat-label>
        <input
          matInput
          [required]="isRequired('font_column', 'label')"
          name="font_column"
          [(ngModel)]="label.font.column"
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <label>{{ 'map.sidebar.shape.style_form.size' | translate }}</label>
      <div class="d-flex gap-2 align-items-center">
        <mat-slider name="font_size" min="1" max="100" step="1" tickInterval="auto">
          <input
            matSliderThumb
            [(ngModel)]="label.font.size"
            [ngModelOptions]="{ standalone: true }"
            [required]="isRequired('font_size', 'label')"
            value="1"
          />
        </mat-slider>
        <label>{{ label.font.size }}</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="d-flex gap-2 align-items-center">
        <label>{{ 'map.sidebar.shape.style_form.halo_radius' | translate }}</label>
        <mat-icon inline="true" matTooltip="Reset" (click)="label.halo.radius = 0">delete</mat-icon>
      </div>
      <div class="d-flex gap-2 align-items-center">
        <mat-slider name="halo_radius" min="1" max="100" step="1" tickInterval="auto">
          <input
            matSliderThumb
            [(ngModel)]="label.halo.radius"
            [ngModelOptions]="{ standalone: true }"
            [required]="isRequired('halo_radius', 'label')"
            value="1"
          />
        </mat-slider>
        <label>{{ label.halo.radius }}</label>
      </div>
    </div>
    <div class="col-6">
      <mat-form-field>
        <mat-label>{{ 'map.sidebar.shape.style_form.halo_color' | translate }}</mat-label>
        <input
          type="color"
          matInput
          [required]="isRequired('halo_color', 'label')"
          name="halo_color"
          [(ngModel)]="label.halo.fill"
          value="#ff0000"
        />
      </mat-form-field>
    </div>
  </div>
</ng-template>
